import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutlayout_digroup extends Layout {
    sourceDigroup2: DataSource;
    sourceDigroup: DataSource;
    tbDigroupGid: Textbox;
    textboxDigroupDesc: Textbox;
    textboxDigroupGid: Textbox;
    textboxDigroupType: Textbox;
}
